import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components/lib/Image';
import {useTranslation} from 'react-i18next';
import CorrectAlertIcon from '@learningblocks/exp-constants/lib/Images/alert_icon_correct.svg';
import IncorrectAlertIcon from '@learningblocks/exp-constants/lib/Images/alert_icon_incorrect.svg';

import './style.scss';

const TRANSLATION_KEY = {
  PLUGGED_IN_POWERSUPPLY_YES: 'PluggedInPowerSupplyYes.string',
  PLUGGED_IN_POWERSUPPLY_NO: 'PluggedInPowerSupplyNo.string',
  PLUGGED_IN_GELBOX_YES: 'PluggedInGelBoxYes.string',
  PLUGGED_IN_GELBOX_NO: 'PluggedInGelBoxNo.string',
};

export function ListItem(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const TEXT = {
    YES: t(TRANSLATION_KEY[`PLUGGED_IN_${props.type.toUpperCase()}_YES`]),
    NO: t(TRANSLATION_KEY[`PLUGGED_IN_${props.type.toUpperCase()}_NO`]),
  };

  const textPrompt = props.isSuccess ? TEXT.YES : TEXT.NO;

  const renderAlertIcon = () =>
    props.isSuccess ? (
      <Image className='ps_hintItem_icon' src={CorrectAlertIcon} alt='Correct alert icon'/>
    ) : (
      <Image className='ps_hintItem_icon' src={IncorrectAlertIcon} alt='Incorrect alert icon'/>
    );

  return (
    <div className={'ps_hintItem '+ (props.isSuccess? 'ps_hintItem_correct':'')}>
      <span className='ps_hintItem_text'>{textPrompt}</span>
      {renderAlertIcon()}
    </div>
  );
}

ListItem.propTypes = {
  /**
   * bool value that specifies if the condition is success or not
   */
  isSuccess: PropTypes.bool,
  /**
   * text that specifies the warning message
   */
  text: PropTypes.string,
};

ListItem.defaultProps = {
  text: '',
};
